import React from 'react';
import { SnackbarMessage } from 'notistack';
import { Alert } from '@chronosphereio/chrono-ui';
import { AlertSeverity } from './types';

export interface SnackbarContentProps {
  message: SnackbarMessage;
  severity: AlertSeverity;
  action?: React.ReactNode;
}

export const SnackbarContent = React.forwardRef(function SnackbarContent(
  { message, severity, action, ...otherProps }: SnackbarContentProps,
  ref: React.Ref<HTMLDivElement>
) {
  return (
    <Alert
      ref={ref}
      {...otherProps}
      severity={severity}
      sx={{
        minWidth: 300,
        [`&.MuiAlert-root`]: {
          alignItems: 'center',
          gap: 1, // Add spacing between message and action
        },
      }}
      aria-describedby="snackbar-content"
      Action={action}
    >
      <div id="snackbar-content">{message}</div>
    </Alert>
  );
});
